<template>
	<div class="bg-grey-3">
		<div class="row">
			<div :class="getSizeColImage">
				<q-img :src="getAboutImage" :alt="getAboutAlt" />
			</div>

			<div :class="getSizeColAbout">
				<div class="row q-col-gutter-md q-py-xl q-px-xl">
					<div class="col-12 text-h4">{{ $t('about_the') }} {{ $t('project_name') }}</div>

					<div class="col-12">
						{{ getAboutDescription }}
					</div>

					<div class="col-12">
						<q-btn
							outline
							type="submit"
							color="primary"
							class="login-button q-mr-md"
							:label="$t('know_more')"
							@click="$router.push({ name: 'login_about' })"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'KnowMorePortfolio',

	data() {
		return {
			abouts: [],
		}
	},

	computed: {
		...mapGetters({
			id_user_language_selected: 'common/id_user_language_selected',
		}),

		getAboutDescription() {
			return this.abouts.find((obj) => obj.language === this.id_user_language_selected)?.description
		},

		getAboutImage() {
			return this.abouts.find((obj) => obj.language === this.id_user_language_selected)?.image
		},

		getAboutAlt() {
			return this.abouts.find((obj) => obj.language === this.id_user_language_selected)?.image
				?.login_about_image_alt_texts
		},

		getSizeColImage() {
			if (this.$q.platform.is.desktop) return 'col-xs-12 col-sm-12 col-md-5'
			else return 'col-xs-12'
		},

		getSizeColAbout() {
			if (this.$q.platform.is.desktop) return 'col-xs-12 col-sm-12 col-md-7'
			else return 'col-xs-12'
		},
	},

	methods: {
		getKnowMore() {
			this.$axios
				.get(`/etraining_portfolio/about/`)
				.then((response) => {
					this.abouts = response.data.abouts
				})
				.catch((e) => {
					console.log(e)
				})
		},
	},

	created() {
		this.getKnowMore()
	},
}
</script>

<style lang="scss" scoped>
.login-button {
	border-radius: 1.5rem;
}
</style>
